// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "../Profile/ReceivedRequest.css";
// import { updateConnectUsers, viewReceivedInterestRequests } from "../api/api";
// import Swal from "sweetalert2";
// import { environment } from "../../environments/environments";

// const ReceivedRequest = ({ onRequestProcessed }) => {
//   const [allUser, setAllUser] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [currUser, setcurrUser] = useState(null);
//   const [acceptingUserId, setAcceptingUserId] = useState(null);
//   const [rejectingUserId, setRejectingUserId] = useState(null);

//   useEffect(() => {
//     fetchUserData();
//   }, []);

//   const fetchUserData = async () => {
//     setIsLoading(true);
//     try {
//       const userData = localStorage.getItem("currentUser");
//       const parsedUserData = JSON.parse(userData);
//       setcurrUser(parsedUserData);
//       const _id = parsedUserData?.id || parsedUserData?._id;
//       console.log("curruser_id_ReceivedRequest", _id);
//       if (_id) {
//         const currentUser = await viewReceivedInterestRequests({
//           user_id: _id,
//         });
//         console.log("allUser-From1111", currentUser);
//         setAllUser(currentUser?.received_requests || []);
//       }
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleRequest = async (interestedUserId, isConfirmed) => {
//     console.log("Clicked User ID999999999999999999:", interestedUserId);
//     isConfirmed
//       ? setAcceptingUserId(interestedUserId)
//       : setRejectingUserId(interestedUserId);

//     try {
//       const values = {
//         user_id: currUser?.id || currUser?._id,
//         interested_user: interestedUserId,
//         confirm: isConfirmed,
//       };
//       console.log("Request Payload:", values);

//       const response = await updateConnectUsers(values);
//       console.log("Response from API:", response);

//       if (response.success === true) {
//         console.log("55555555555555555555555555");
//         Swal.fire({
//           icon: "success",
//           title: isConfirmed ? "Accepted!" : "Rejected!",
//           text: isConfirmed
//             ? "You have accepted the request."
//             : "You have rejected the request.",
//         }).then(fetchUserData);

//         if (onRequestProcessed) onRequestProcessed();
//       }
//     } catch (error) {
//       console.error("Error updating user", error);
//     } finally {
//       setAcceptingUserId(null);
//       setRejectingUserId(null);
//     }
//   };
//   return (
//     <div className="receiving-request-container">
//       {isLoading ? (
//         <div className="loading">Loading...</div>
//       ) : allUser.length > 0 ? (
//         <div className="requests-list">
//           {allUser.map((user, index) => (
//             <div key={user.id || index} className="request-item">
//               <div className="img-div">
//                 <img
//                   src={
//                     user.more_images?.length &&
//                     `${environment.url}/uploads/users/${user.more_images[0]}`
//                   }
//                   alt="User"
//                   className="user-image-received"
//                 />
//               </div>
//               <div className="user-info">
//                 <h3>{user.name}</h3>
//                 <p>{user.age} Years</p>
//               </div>
//               <div className="action-buttons-received-Request">
//                 <button
//                   className="accept-button"
//                   onClick={() => handleRequest(user.id, true)}
//                   disabled={acceptingUserId === user.id}
//                 >
//                   Accept
//                 </button>
//                 <button
//                   className="accept-button"
//                   onClick={() => handleRequest(user.id, false)}
//                   disabled={rejectingUserId === user.id}
//                 >
//                   Reject
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       ) : (
//         <div className="no-requests">
//           <p className="no-requests-text">No requests available </p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ReceivedRequest;

// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "../Profile/ReceivedRequest.css";
// import { updateConnectUsers, viewReceivedInterestRequests } from "../api/api";
// import Swal from "sweetalert2";
// import { environment } from "../../environments/environments";

// const ReceivedRequest = ({ onRequestProcessed }) => {
//   const [allUser, setAllUser] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [currUser, setcurrUser] = useState(null);
//   const [acceptingUserId, setAcceptingUserId] = useState(null);
//   const [rejectingUserId, setRejectingUserId] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);

//   useEffect(() => {
//     fetchUserData();
//   }, []);

//   const fetchUserData = async () => {
//     setIsLoading(true);
//     try {
//       const userData = localStorage.getItem("currentUser");
//       const parsedUserData = JSON.parse(userData);
//       setcurrUser(parsedUserData);
//       const _id = parsedUserData?.id || parsedUserData?._id;
//       console.log("curruser_id_ReceivedRequest", _id);
//       if (_id) {
//         const currentUser = await viewReceivedInterestRequests({
//           user_id: _id,
//         });
//         console.log("allUser-From1111", currentUser);
//         setAllUser(currentUser?.received_requests || []);
//       }
//     } catch (error) {
//       console.error("Error fetching user data:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleRequest = async (interestedUserId, isConfirmed) => {
//     console.log("Clicked User ID999999999999999999:", interestedUserId);
//     isConfirmed
//       ? setAcceptingUserId(interestedUserId)
//       : setRejectingUserId(interestedUserId);

//     try {
//       const values = {
//         user_id: currUser?.id || currUser?._id,
//         interested_user: interestedUserId,
//         confirm: isConfirmed,
//       };
//       console.log("Request Payload:", values);

//       const response = await updateConnectUsers(values);
//       console.log("Response from API:", response);

//       if (response.success === true) {
//         console.log("55555555555555555555555555");
//         Swal.fire({
//           icon: "success",
//           title: isConfirmed ? "Accepted!" : "Rejected!",
//           text: isConfirmed
//             ? "You have accepted the request."
//             : "You have rejected the request.",
//         }).then(fetchUserData);

//         if (onRequestProcessed) onRequestProcessed();
//       }
//     } catch (error) {
//       console.error("Error updating user", error);
//     } finally {
//       setAcceptingUserId(null);
//       setRejectingUserId(null);
//     }
//   };
//   return (
//     <div className="receiving-request-container">
//       <div className="receiveHeadingText">
//         <h1>Request you have Recived</h1>
//       </div>
//       <div className="receiveHeadingSubText">
//         <p>
//           Lorem Ipsum is simply dummy text of the printing and typesetting
//           industry. Lorem Ipsum has been the industry's standard dummy text ever
//           since the 1500s
//         </p>
//       </div>
//       <div className="line"></div>
//       {isLoading ? (
//         <div className="loading">Loading...</div>
//       ) : allUser.length > 0 ? (
//         <div>
//           <div className="numberOfTextdiv">
//             <p>
//               You have <strong>{allUser?.length} Requests</strong> to react...
//             </p>
//           </div>
//           <div className="requests-list">
//             {allUser.map((user, index) => (
//               <div key={user.id || index} className="request-item">
//                 <div
//                   className="img-div"
//                   onClick={() => {
//                     setSelectedUser(user);
//                     setShowModal(true);
//                   }}
//                 >
//                   <img
//                     src={
//                       user.more_images?.length &&
//                       `${environment.url}/uploads/users/${user.more_images[0]}`
//                     }
//                     alt="User"
//                     className="user-image-received"
//                     // onClick={() => {
//                     //   setSelectedUser(user);
//                     //   setShowModal(true);
//                     // }}
//                   />
//                   <div className="user-info">
//                     <h3>{user.name}</h3>
//                     <p>{user.age} Years</p>
//                   </div>
//                 </div>
//                 {/* <div className="user-info">
//                 <h3>{user.name}</h3>
//                 <p>{user.age} Years</p>
//               </div> */}
//                 {/* <div className="action-buttons-received-Request">
//                 <button
//                   className="accept-button"
//                   onClick={() => handleRequest(user.id, true)}
//                   disabled={acceptingUserId === user.id}
//                 >
//                   Accept
//                 </button>
//                 <button
//                   className="accept-button"
//                   onClick={() => handleRequest(user.id, false)}
//                   disabled={rejectingUserId === user.id}
//                 >
//                   Reject
//                 </button>
//               </div> */}
//               </div>
//             ))}
//           </div>
//         </div>
//       ) : (
//         <div className="no-requests">
//           <p className="no-requests-text">No requests available </p>
//         </div>
//       )}
//       {/* {showModal && selectedUser && (
//         <div className="modal-overlay">
//           <div className="modal-content">
//             <span className="close-button" onClick={() => setShowModal(false)}>
//               &times;
//             </span>
//             <img
//               src={`${environment.url}/uploads/users/${selectedUser.more_images[0]}`}
//               alt="User"
//               className="modal-image"
//             />
//             <h2>{selectedUser.name}</h2>
//             <p>Age: {selectedUser.age} Years</p>
//             <p>Location: {selectedUser.location || "Unknown"}</p>

//             <div className="modal-actions">
//               <button
//                 className="accept-button"
//                 onClick={() => {
//                   handleRequest(selectedUser.id, true);
//                   setShowModal(false);
//                 }}
//                 disabled={acceptingUserId === selectedUser.id}
//               >
//                 Accept
//               </button>
//               <button
//                 className="accept-button"
//                 onClick={() => {
//                   handleRequest(selectedUser.id, false);
//                   setShowModal(false);
//                 }}
//                 disabled={rejectingUserId === selectedUser.id}
//               >
//                 Reject
//               </button>
//             </div>
//           </div>
//         </div>
//       )} */}

//       {showModal && selectedUser && (
//         <div className="custom-modal-overlay">
//           <div className="custom-modal-content">
//             <div className="modal-image-container">
//               <img
//                 src={`${environment.url}/uploads/users/${selectedUser.more_images[0]}`}
//                 alt="User"
//                 className="modal-profile-image"
//               />
//             </div>
//             <div className="modal-details">
//               <h2 className="modal-username">{selectedUser.name}</h2>
//               <div className="modal-info-grid">
//                 <div className="labelText">
//                   {/* <h1 className="label">Age</h1>
//                   <p className="dotss">:</p> */}
//                   <p>{selectedUser.age} Years</p>
//                 </div>
//               </div>
//               <p className="modal-description">
//                 Lorem Ipsum is simply dummy text of the printing and typesetting
//                 industry. Lorem Ipsum has been the industry's standard dummy
//                 text ever since the 1500s.
//               </p>
//               <div className="modal-action-buttons">
//                 <button
//                   className="accept-btn-receive"
//                   onClick={() => {
//                     handleRequest(selectedUser.id, true);
//                     setShowModal(false);
//                   }}
//                 >
//                   Accept
//                 </button>
//                 <button
//                   className="reject-btn-receive"
//                   onClick={() => {
//                     handleRequest(selectedUser.id, false);
//                     setShowModal(false);
//                   }}
//                 >
//                   Reject
//                 </button>
//               </div>
//             </div>
//             <span className="modal-close" onClick={() => setShowModal(false)}>
//               &times;
//             </span>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ReceivedRequest;

import React, { useCallback, useEffect, useState } from "react";
import "../Profile/ReceivedRequest.css";
import { viewReceivedInterestRequests, updateConnectUsers } from "../api/api";
import { useSelector } from "react-redux";
import moment from "moment";
import { environment } from "../../environments/environments";
import Swal from "sweetalert2";

const ReceivedRequest = ({ onRequestProcessed }) => {
  const [allUser, setAllUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currUser, setCurrUser] = useState(null);

  // const deviceToken = useSelector(state => state.deviceToken.token);

  const fetchUserData = useCallback(async () => {
    setIsLoading(true);
    try {
      const storedUser = localStorage.getItem("currentUser");
      const parsedUser = JSON.parse(storedUser);
      setCurrUser(parsedUser);

      const _id = parsedUser?.id || parsedUser?._id;
      if (_id) {
        const currentUser = await viewReceivedInterestRequests({
          user_id: _id,
        });

        const mappedPending = currentUser?.pending_connections?.map((item) => ({
          ...item.from_user,
          request_received_on: item.created_at,
          connection_id: item.id,
          isPendingConnection: true,
        }));

        const received = currentUser?.received_requests || [];
        const allCombined = [...mappedPending, ...received];
        setAllUser(allCombined);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUserData();
  }, [fetchUserData]);

  const handleRequest = async (interestedUserId, confirm) => {
    try {
      const values = {
        user_id: currUser?.id || currUser?._id,
        interested_user: interestedUserId,
        confirm,
      };
      const response = await updateConnectUsers(values);
      // if (response?.success && onRequestProcessed) {
      //   onRequestProcessed();
      //   fetchUserData();
      // }
      if (response?.success /*&& onRequestProcessed*/) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message,
        }).then(() => {
          // onRequestProcessed();
          fetchUserData();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response?.message,
        }).then(() => {
          // if (onRequestProcessed) {
          // onRequestProcessed();
          fetchUserData();
          // }
        });
      }
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  return (
    <div className="received-request-container">
      {isLoading ? (
        <div className="loader"></div>
      ) : allUser.length > 0 ? (
        allUser.map((user, index) => (
          <div
            key={index}
            /*className="user-card"*/ className="connection-card"
          >
            <div className="image-name-div">
              <img
                src={
                  user?.pre_consent_for_displaying_images &&
                  user?.more_images?.length
                    ? `${environment.url}/uploads/users/${user.more_images[0]}`
                    : "/user-icon.png"
                }
                alt="Profile"
                // className="profile-image"
                className="connection-image"
              />
              <div className="connection-user-info">
                <div className="receivedconnection-name">{user?.name}</div>
                <div className="connection-name">{user?.age} Years</div>
              </div>
            </div>
            <div className="connection-actions">
              {user?.isPendingConnection ? (
                <button className="connection-btn pending" disabled>
                  Pending
                </button>
              ) : (
                <>
                  <button
                    className="connection-btn chat"
                    onClick={() => handleRequest(user?.id, true)}
                  >
                    Accept
                  </button>
                  <button
                    className="connection-btn remove"
                    onClick={() => handleRequest(user?.id, false)}
                  >
                    Reject
                  </button>
                </>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="no-data">No requests available</div>
      )}
    </div>
  );
};

export default ReceivedRequest;
